/**
 * Embed postMessage-protocol — origin-allowlist per embed.
 * Inbound: pause/resume/goto_room/set_lang
 * Outbound: ready, view_start/end, hotspot_click, cta_click, etc.
 */

const allowedParentOrigins = (import.meta.env.VITE_ALLOWED_ORIGINS as string | undefined)?.split(',') ?? [];

export function mountPostMessage(): void {
  window.addEventListener('message', (ev) => {
    if (allowedParentOrigins.length > 0 && !allowedParentOrigins.includes(ev.origin)) return;
    const data = ev.data as { type?: string; payload?: unknown } | null;
    if (!data?.type) return;
    document.dispatchEvent(new CustomEvent('hs-viewer-inbound', { detail: data }));
  });

  // Send ready
  window.parent.postMessage({ type: 'ready', v: 1 }, '*');

  document.addEventListener('hs-viewer-action', (ev) => {
    const detail = (ev as CustomEvent<{ action: string }>).detail;
    window.parent.postMessage({ type: detail.action, v: 1 }, '*');
  });
}
